export const TOGGLE_Special_FILTER_MENU = 'ibw/SearchSpecial/TOGGLE_Special_FILTER_MENU';
